
/**
 * @todo Назначения цветам типов, нужно вынести в конфигурацию
 * @deprecated
 */
import {TaskInterface} from "./Task";

export const enum ColorFixture {
    Freelance = 36,
    Work = 41,
    Person = 45,
    SkillBuilding = 32
}

/**
 * Интерфейс для опций билдера. Расширяется при реализации конкретного билдера
 * если билдеру нужны будут дополнительные опции для построения объекта
 * Интерфейс наследуется в компоненте который реализует конкретный билдер
 */
export interface BuilderOptionInterface {
    props: {}
}



/**
 * Интерфейс билдера, классы реалезующие эти интерфейсы умеют строить объекты
 * на основе переданного источника данных. Основная задача это конвертация
 * данных из TodoSync в данные приложения
 */
export interface BuilderInterface<S, To> {


    build(source: S): To;
}

/**
 * Директор сторит из массива объектов TodoSync массив объектов приложения, используя BuilderInterface
 * @see BuilderInterface
 */
export class Director<S, To> {

    constructor(private sources: S[], private builder: BuilderInterface<S, To>){

    }

    getResults() : Collection<To>{
        let results:To[] = [];
        this.sources.forEach((source)=>{
            results.push(this.builder.build(source))
        });
        return new Collection<To>(results);


    }


}

/**
 *
 * @deprecated в замен фабрики будет использоваться билдер
 */
export interface FactoryInterface<T, U> {

    create(item: T): U;
}

export interface GroupInterface<G, I> {

    group: G
    , items: Collection<I>

}



export  interface FilterInterface<T> {
    (item: T, index: number, array?: T[]): boolean;
}

export  interface GroupMethodInterface<T, G> {
    (item: T): G;
}

/**
 * В Collection<T> передается массив с объектами заданного типа <T>
 * В колеции могут быть только уникальные объекты
 *
 * Рекомендации:
 * Для упращения работы фильтров и группировок рекумендуется 2 похода
 * - Создать класс который содержит заранее подготовленные фукнции для фильтрации и группировки
 * - Создать специальный класс методы которого смогут выполнять какие то дейсвтия с кооллекцией возвращая определнный результат
 *
 */
export class Collection<T> {

    private items: T[] = [];
    private collection: Collection<T>;

    constructor(labels: T[] = []) {

        labels.forEach((item: T) => {
            this.addItem(item)
        })

    }

    private getInstance<S>(): Collection<S> {
        return new Collection<S>();
    }

    addItem(label: T): void {
        if (this.items.indexOf(label) == -1) {
            this.items.push(label)
        }

    }

    getItems(): T[] {
        return this.items;
    }

    sum(callback: (item: T) => number): number {
        let sum = 0;
        this.items.forEach(function (item, index, array) {
            sum += callback(item)
        });
        return sum;
    }

    sort(callback: (itemOne : T, itemTwo: T) => number): Collection<T>{
        this.getItems().sort(callback);
        return this;
    }


    filter<O extends T>(callback: FilterInterface<T>): Collection<O> {
        let collection: Collection<O> = this.getInstance<O>();
        this.items.filter(callback).forEach((value) => {
            collection.addItem(<O>value);
        });
        return collection;
    }

    findItem(item: T): T | undefined {
        return this.find(value => value == item)
    }
    find(predicate: (item: T, index: number, obj: T[]) => boolean) {
        return this.getItems().find(predicate);
    }

    group<G>(getGroupBy: GroupMethodInterface<T, G>): Collection<GroupInterface<G, T>>{
        let groups = this.getInstance<GroupInterface<G, T>>();
        this.getItems().forEach((item, index, array)=>{

            let groupsBy = getGroupBy(item);
            let group: GroupInterface<G, T>;
            if(!(group = groups.find(value => value.group == groupsBy))) {
                group =  {group: groupsBy, items: new Collection<T>()}
            }

            group.items.addItem(item);

            if(!groups.find(value => value.group == groupsBy ) ){
                groups.addItem(group)
            }

        });
        return groups;
    }



    isset(item: T): boolean{
       return  this.items.indexOf(item) != -1;
    }

    get length(): number{
        return  this.items.length;
    }

}

export interface EntityTimeInterface {

    getTime(): TimeFormatInterface;

}

export interface TimeFormatInterface {

    toSeconds(): number;
    toMinute(): number;
    toFormat(): {minute: number, hour: number};
    toTomato(): number;
    toString(): number;

}


export class TimeFormat implements  TimeFormatInterface{

    constructor(private time: number){

    }
    toString(){
        return this.time

    }
    toSeconds(){
        return this.time * 60;
    }

    toMinute(): number{
        return this.time
    }
    toHour(): number{
        return  (Math.ceil(this.time/60*100))/100;
    }

    toFormat(){
        let hour = Math.floor(this.time / 60);
        let minute = (this.time - (hour*60));
        return {
            minute: minute,
            hour: hour
        }
    }

    toTomato(){
        return Math.ceil(this.time/25);
    }


}


export class  BreakException  {

}

export class DateParse {
    private date: string;


    constructor(date: string){
        this.date = date;
    }
    createDate(){
        let dateValue =  this.date.match(new RegExp('(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2})T(?<hour>[0-9]{2}):(?<minute>[0-9]{2}):(?<second>[0-9]{2})$'));
        if(!dateValue){
           let date =  new Date(this.date);

           /*
           * Если не найден указатель часового пояса занчит
           * просто дата без вермени то устанавливаем часы в "0"
           **/
           if(this.date.search("Z") == -1) {
               date.setHours(0);
               date.setMinutes(0);
               date.setSeconds(0);
           }
            return  date;

        }
        let date =  new Date([dateValue.groups.year,dateValue.groups.month,dateValue.groups.day  ].join('-'));
        date.setHours(Number(dateValue.groups.hour));
        date.setMinutes(Number(dateValue.groups.minute));
        date.setSeconds(Number(dateValue.groups.second));
        return date;
    }


}